import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import config from 'Config'
import { PAGE_CONTEXT as p } from 'Constants'
import { PageHelmet } from 'Blocks'

const HelmetTitle = props => {
  const journeySeparator = config.helmet.metaTitleFormat.journeySeparator

  const buildJourney = () => {
    if (config.useMainMenu) {
      let path = [...props.currentPath]
      if (!path.includes(props.currentCategory)) {
        path.push(props.currentCategory)
      }

      path.shift()
      let journey = props.categoryName

      if (path.length > 1) {
        const categories = path.map(
          uuid =>
            props.categoryTree.filter(category => category.uuid === uuid)[0]
        )

        if (categories.length > 0) {
          journey = categories
            .map((c, index) => {
              return index === 0
                ? `${c.name} `
                : `${journeySeparator} ${c.name} `
            })
            .reduce((acc, name) => acc + name, '')
        }
      }
      return journey
    }

    if (props.items.length) {
      return `${props.items[0].name} ${props.items
        .slice(1)
        .map(item => `${journeySeparator} ${item.name} `)
        .reduce((acc, name) => acc + name, '')}`
    }
    return props.categoryName
  }

  const pageName = p.PRODUCT_LIST

  const description =
    config.locale === 'de'
      ? `Geschäft ${props.categoryName} bei ${config.helmet.partner}`
      : `Shop ${props.categoryName} at ${config.helmet.partner}`
  return (
    <PageHelmet
      pageName={pageName}
      titleFormat={{
        JOURNEY: buildJourney(),
        CURRENT_CATEGORY: props.categoryName
      }}
      description={description}
    />
  )
}

HelmetTitle.propTypes = {
  categoryName: PropTypes.any,
  categoryTree: PropTypes.array,
  currentCategory: PropTypes.any,
  currentPath: PropTypes.any,
  items: PropTypes.array
}

const mapStateToProps = state => {
  return {
    items: [...state.journey.track.items],
    currentPath: state.UI.mainMenu.currentPath,
    currentCategory: state.UI.mainMenu.currentCategory,
    categoryTree: state.UI.mainMenu.categoryTree
  }
}

export default connect(mapStateToProps, null)(HelmetTitle)
